import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../store';
import { cultureChange } from '../../store/cultures/actions';
import { getUiLocalesFromParts, getValidCulture } from '../../utils/userLanguage';

const Logout: React.FC = () => {

	const nav = useNavigate();
	const dispatch = useDispatch();
	const cultures = useSelector((state: AppState) => state.cultures.cultures);

	useEffect(() => {
		// Redirect to path saved in sessionStorage if existing - else redirect to root
		const redirectAfterLogout = sessionStorage.getItem('redirectAfterLogout');

		sessionStorage.removeItem('redirectAfterLogout');

		if (redirectAfterLogout) {
			const { search, hash } = new URL(redirectAfterLogout, globalThis.location.origin);
			const uiLocales = getUiLocalesFromParts(search, hash);
			const validCulture = getValidCulture(cultures, uiLocales);
			if (validCulture) {
				dispatch(cultureChange(validCulture));
			}
		}

		nav(redirectAfterLogout || "/");

	  // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, []);

	return null;
}

export default Logout;
